import PropertyAdditionalFee from './PropertyAdditionalFee';

export default PropertyAdditionalFee;
